import moment from 'moment-timezone';

const FormattingService = {
  formatRelativeUrl: (item) => {
    if ('instructor' === item.type) {
      return `/author/${item.slug}/`;
    }
    let url = '/';
    const parts = ['type', 'slug'];
    for (const part of parts) {
      url = `${url}${item[part]}/`;
    }
    return url;
  },
  formatUrl: (item) => {
    if (item.url) {
      return item.url; // Direct link to content. Link is generated based on the Website serving the HTTP request.
    }

    return FormattingService.formatRelativeUrl(item);
  },
  formatYear: (date) => {
    return moment(String(date)).format('YYYY');
  },
  formatDate: (date) => {
    return moment(String(date)).format('MMMM YYYY');
  },
  formatDateMonthDayYear: (date) => {
    return moment(String(date)).format('MMMM D, YYYY');
  },
  formatDateEventCard: (date) => {
    return moment(String(date)).format('MMMM Do, YYYY');
  },
  formatDateTimeWithZone: (date) => {
    let zone = moment.tz.guess();
    let zoneName = moment().tz(zone).zoneAbbr();
    return moment(String(date)).format('MMMM D, YYYY, h:mm a') + ' ' + zoneName;
  },
  formatDateForDB: (date) => {
    return moment(String(date)).format('YYYY-MM-DD HH:mm:ss');
  },
  formatDuration: (seconds) => {
    seconds = parseInt(seconds);
    if ('undefined' == typeof seconds || Number.isNaN(seconds)) {
      seconds = 0;
    }
    let formatted = moment.utc(seconds*1000).format('H:m:s');
    let split = formatted.split(":");
    let hours = split[0] === '0' ? '' : `${split[0]}H`;
    let minutes = split[1] === '0' ? '' : `${split[1]}M`;
    let sec = split[2] === '0' ? '' : `${split[2]}S`;

    return `${hours} ${minutes} ${sec}`.trim();

  },
  linkedInstructorArray: (array) => {
    if (1 === array.length) {
      return 'With <span class="koc-instructor-link"><a href="' + FormattingService.formatUrl(array[0]) + '">' + array[0].name.display + '</a></span>';
    } else {
      let text = 'With ';
      for (let i = 0; i < array.length; i++) {
        if (i === array.length - 2) {
          text += '<span class="koc-instructor-link"><a href="' + FormattingService.formatUrl(array[i]) + '">' + array[i].name.display + '</a></span>' + ' & ';
        } else if (i === array.length - 1) {
          text += '<span class="koc-instructor-link"><a href="' + FormattingService.formatUrl(array[i]) + '">' + array[i].name.display + '</a></span>';
        } else {
          text += '<span class="koc-instructor-link"><a href="' + FormattingService.formatUrl(array[i]) + '">' + array[i].name.display + '</a></span>' + ', ';
        }
      }
      return text;
    }
  },

  memberDashboardLinkedInstructorArray: (array) => {
    if(1 === array.length) {
      return 'With: <a style="color: var(--koc-text-default); text-decoration:none" href="' + FormattingService.formatUrl(array[0]) + '">' + array[0].name.display + '</a>';
    } else {
      let text = 'With ';
      for (let i = 0; i < array.length; i++) {
        if (i === array.length - 2) {
          text += '<a style="color: var(--koc-text-default); text-decoration:none" href="' + FormattingService.formatUrl(array[i]) + '">' + array[i].name.display + '</a>' + ' & ';
        } else if (i === array.length - 1) {
          text += '<a style="color: var(--koc-text-default); text-decoration:none" href="' + FormattingService.formatUrl(array[i]) + '">' + array[i].name.display + '</a>';
        } else {
          text += '<a style="color: var(--koc-text-default); text-decoration:none" href="' + FormattingService.formatUrl(array[i]) + '">' + array[i].name.display + '</a>' + ', ';
        }
      }
      return text;
    }
  },

  formatViewAllUrl: (url) => {
    let temp = url.split('/');
    url = url.replace(temp[temp.length-2] + '/', '');
    return url;
  },

  formatCommunityUrl: (url, item) => {
    return `${url}/t/${item.id}`;
  },

  formatBaseUrl: (url) => {
    return url.replace('wp-json/ko', '');
  },

  formatDownloadUrl: (item) => {
    if(!item) return '#';
    return item[0].link;
  },
  formatPriceCents: (cents) => {
    if (Number.isNaN(Number(cents))) return '0';
    const isWhole = cents % 100 === 0;
    const dollars = cents / 100;
    return isWhole ? dollars.toFixed(0) : dollars.toFixed(2);
  },


};



export default FormattingService;
